import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import app from '@/store/app/index.js';
import register from '@/views/register/store/register.index.js';
import signin from '@/views/signin/store/signin.index.js';
import publishPurchase from '@/views/publish-purchase/store/publish-purchase.index.js';
import transaction from '@/views/transaction-pro/store/transaction.index.js';
import home from '@/views/home/store/home.index.js';
import messageCenter from '@/views/person-center/message-center/store/message.index.js';
import projectInfo from '@/views/publish-project/project-info/store/index.js';
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'rongxin.chanquan.portal.tiandong',
  modules: ['app', 'register', 'publishPurchase', 'transaction', 'home', 'projectInfo']
});

export default new Vuex.Store({
  modules: {
    app,
    register,
    signin,
    publishPurchase,
    transaction,
    home,
    messageCenter,
    projectInfo
  },
  plugins: [vuexLocal.plugin]
});
